import ListIcon from './ListIcon';

/**
 * A record named on a line, as in « Entreprises du groupe »: its icon in a
 * small frame (ListIcon `size`), its name and a line under it (`detail`).
 * `uppercase`: a company name, written in capitals. `nameClassName` adds to
 * the name (an underline on hover).
 */
const ListIdentity = ({ icon, name, detail, uppercase = false, size = 'md', nameClassName = '' }) => (
  <span className="flex min-w-0 items-center gap-3">
    <ListIcon icon={icon} size={size} />
    <span className="min-w-0">
      <span className={`block truncate text-sm font-medium text-gray-900 ${uppercase ? 'uppercase' : ''} ${nameClassName}`}>
        {name}
      </span>
      {detail && <span className="block truncate text-xs text-gray-600">{detail}</span>}
    </span>
  </span>
);

export default ListIdentity;
